import { Component } from "@angular/core";

@Component({
    templateUrl:'./create-batch-order.html',
    styleUrls:['./create-batch-order.scss']
})
export class CreateBatchOrderComponent{


}